/**
 * Admin crew notes — private notes admins/owners keep about a crew member.
 * Admin/owner-only API; the crew member never sees these.
 */

import { api } from './client';

export interface CrewNote {
  id: string;
  body: string;
  createdAt: string;
  author: { id: string; firstName: string; lastName: string };
}

export async function listCrewNotes(userId: string): Promise<CrewNote[]> {
  const response = await api.get<{ notes: CrewNote[] }>(`/users/${userId}/notes`);
  return response.data.notes;
}

export async function createCrewNote(userId: string, body: string): Promise<CrewNote> {
  const response = await api.post<{ note: CrewNote }>(`/users/${userId}/notes`, { body });
  return response.data.note;
}

export async function deleteCrewNote(userId: string, noteId: string): Promise<void> {
  await api.delete(`/users/${userId}/notes/${noteId}`);
}
